var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVolume(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "master_svg0_2701_9860"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    rx: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#master_svg0_2701_9860)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.889,15.99996103553772L5,15.99996103553772C4.447715,15.99996103553772,4,15.55226103553772,4,14.99996103553772L4,9.00000103553772C4,8.447711035537719,4.447715,8.00000103553772,5,8.00000103553772L8.889,8.00000103553772L14.183,3.6680000355377196C14.3325,3.5454199355377196,14.5393,3.5200295355377196,14.714,3.6027975355377198C14.8888,3.68556503553772,15.0001,3.86165603553772,15,4.05500003553772L15,19.94496103553772C15.0001,20.13836103553772,14.8888,20.314461035537718,14.714,20.39716103553772C14.5393,20.47996103553772,14.3325,20.45456103553772,14.183,20.33196103553772L8.89,15.99996103553772L8.889,15.99996103553772ZM18.863,16.59096103553772L17.441000000000003,15.16896103553772C18.425,14.41236103553772,19.0011,13.24123103553772,19,12.00000103553772C19,10.57000103553772,18.25,9.315001035537719,17.119999999999997,8.60800103553772L18.558999999999997,7.16900103553772C20.0952,8.29904103553772,21.0016,10.09294103553772,21,12.00000103553772C21,13.84196103553772,20.17,15.48996103553772,18.863,16.59096103553772Z",
    fillOpacity: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolume);
export default __webpack_public_path__ + "static/media/volume.e07f1c00c70347d1e4169abb568899f5.svg";
export { ForwardRef as ReactComponent };